import { createApi } from '@reduxjs/toolkit/query/react';
import { AuthLoginResponse, LoginFormValues } from 'types';
import { createBaseQueryWithAuth } from '../../utils/baseQuery';
import { API_ROUTES } from '../../constants/API_ROUTES';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: createBaseQueryWithAuth(`${process.env.REACT_APP_API_URL}/api/channel-partner-admin`),
    endpoints: (builder) => ({
    validateToken: builder.query<any, string>({
      query: (token) => `/validate-token/?token=${token}`,
    }),
    getAuthToken: builder.mutation<AuthLoginResponse, LoginFormValues>({
      query: (body) => ({
        url: API_ROUTES.auth.login,
        method: 'POST',
        body,
      }),
      extraOptions: {
        bypassChecksum: true,
      },
    }),
    logout: builder.mutation<any, { clearDeviceData?: boolean }>({
      query: (params = {}) => ({
        url: API_ROUTES.auth.logout,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useValidateTokenQuery, useGetAuthTokenMutation, useLogoutMutation,
} = authApi;
